import type { PropertiesTableProps } from '../../shared/types'
import { ParagraphProperties } from './PDocs'

export const IngressProperties: PropertiesTableProps = {
  ...ParagraphProperties,
}
